/**
 * Best-effort message extraction for mutation/network errors.
 */
export function extractErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error) {
    return err.message;
  }
  if (
    typeof err === "object" &&
    err !== null &&
    "message" in err &&
    typeof (err as { message: string }).message === "string"
  ) {
    return (err as { message: string }).message;
  }
  return fallback;
}
